(function() {
  'use strict';

  function initBlk2Stars() {
    // metafield judgeme.badge ベースの Liquid 出力で完結。
    // hidden 属性は Liquid 側で metafield 空時のみ付与されるため、
    // JS 側での件数判定・表示制御は不要。
    // （将来 JS 動的描画方式へ戻す場合に備えて関数自体は残置）
  }

  function getStickyHeaderOffset() {
    const candidates = [
      'sticky-header',
      '.shopify-section-header-sticky',
      '.shopify-section-header',
      '.header-wrapper',
      '.section-header'
    ];
    for (const sel of candidates) {
      const el = document.querySelector(sel);
      if (el) {
        const h = el.getBoundingClientRect().height;
        if (h > 0) return h + 8;
      }
    }
    return 80;
  }

  function initAnchorScroll() {
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-jc-scroll-to-reviews]');
      if (!link) return;
      e.preventDefault();
      const target = document.getElementById('jc-blk7-reviews');
      if (!target) return;
      const headerOffset = getStickyHeaderOffset();
      const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  }

  function initEmptyStateDetection() {
    const widgetContainer = document.getElementById('judgeme_product_reviews');
    const emptyState = document.querySelector('[data-jc-blk7-empty]');
    if (!widgetContainer || !emptyState) return;

    const checkRendered = () => {
      const widg = widgetContainer.querySelector('.jdgm-rev-widg');
      if (!widg) return false;
      const reviewCount = parseInt(widg.dataset.numberOfReviews || '0', 10);
      if (reviewCount > 0) {
        emptyState.hidden = true;
        return true;
      }
      return false;
    };

    if (checkRendered()) return;

    const observer = new MutationObserver(() => {
      if (checkRendered()) observer.disconnect();
    });
    observer.observe(widgetContainer, { childList: true, subtree: true });

    setTimeout(() => {
      if (!checkRendered()) {
        emptyState.hidden = false;
      }
      observer.disconnect();
    }, 5000);
  }

  function initPaginationScrollFix() {
    document.addEventListener('click', (e) => {
      const link = e.target.closest(
        '.jdgm-paginate__page, .jdgm-paginate__next-page, .jdgm-paginate__prev-page'
      );
      if (!link) return;

      setTimeout(() => {
        const widget = document.querySelector('.jdgm-rev-widg');
        if (!widget) return;
        const headerOffset = getStickyHeaderOffset();
        const top = widget.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({ top, behavior: 'smooth' });
      }, 250);
    });
  }

  function init() {
    initBlk2Stars();
    initAnchorScroll();
    initEmptyStateDetection();
    initPaginationScrollFix();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
